import Alpine from 'alpinejs';

Alpine.data('header', function(){
  return {
    currentMenu: null,
    openMenu(menuName){
      if(this.currentMenu === menuName){
        this.closeCurrentMenu()
        return
      }
      this.currentMenu = menuName
    },
    closeCurrentMenu(){
      this.currentMenu = null
    }
  }
})
